import { Configuration } from '../api/drugConfigurationQuery'

import { ConfigType, SavedConfig } from './types'

type Option = {
  gpi: string
  ndc: string
  package: string
  form: string
  dosage: string
}

const mapping = new Map<ConfigType, keyof Option>()
  .set(ConfigType.Form, 'form')
  .set(ConfigType.Dosage, 'dosage')
  .set(ConfigType.TypeOfQuantity, 'package')

export const findBestConfigMatch = (
  options: Option[],
  config: SavedConfig,
): Partial<SavedConfig> => {
  const current: Partial<SavedConfig> = {
    [ConfigType.Form]: '',
    [ConfigType.Dosage]: '',
    [ConfigType.TypeOfQuantity]: '',
  }
  let list = options

  for (const key of mapping.keys()) {
    list = list.filter((item) => item[mapping.get(key)!] === config[key])
    if (list.length === 0) return current

    current[key] = config[key]
  }

  return current
}

export const filterSavedConfig = (
  savedConfig: SavedConfig,
  options: Option[],
) => {
  const result = findBestConfigMatch(options, savedConfig)
  return { ...savedConfig, ...result }
}

const getDaysSupplyValue = (days?: number | null) => {
  if (!days) return ''

  switch (days) {
    case 30:
    case 60:
    case 90:
      return days.toString()
    default:
      return 'custom'
  }
}

export const mapDefaultConfiguration = (config: Configuration) => ({
  [ConfigType.DaysSupply]: getDaysSupplyValue(config.daysSupply),
  [ConfigType.DaysSupplyCustom]: config.daysSupply?.toString(),
  [ConfigType.Form]: config.form,
  [ConfigType.Dosage]: config.dosage,
  [ConfigType.TypeOfQuantity]: config.package,
  [ConfigType.Quantity]: config.quantity?.toString(),
})
